import { render, staticRenderFns } from "./SubmissionOverview.vue?vue&type=template&id=92deb39e&scoped=true"
import script from "./SubmissionOverview.vue?vue&type=script&lang=js"
export * from "./SubmissionOverview.vue?vue&type=script&lang=js"
import style0 from "./SubmissionOverview.vue?vue&type=style&index=0&id=92deb39e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92deb39e",
  null
  
)

export default component.exports